import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Form, InputGroup, Button, Card, Collapse } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SoftBadge from 'components/common/SoftBadge';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const FiltrosContactos = ({
    vendedor,
    setVendedor,
    etapa,
    setEtapa,
    catEtapas,
    setCatEtapas,
    ordenarPor,
    setOrdenarPor,
    idSource_,
    setidSource_,
    tags,
    Filter_Tags,
    setFilter_Tags,
    mostrarLeads,
    filtroEventosVencidos,
    Filter_NumTelNameLead,
    setFilter_NumTelNameLead,
    filtroEventos,
    handleCheckedFiltroEventos,
    filtroEventosVencidos: filtroEventosVencidosState,
    handleCheckedFiltroEventosVencidos,
    cargando
}) => {
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
    const [vendedores, setVendedores] = useState([]);
   // const [catEtapas, setCatEtapas] = useState([]);
    const [cargandoVendedores, setCargandoVendedores] = useState(false);
    const [cargandoEtapas, setCargandoEtapas] = useState(false);
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    useEffect(() => {
        fetchVendedores();
        fetchEtapas();
    }, []);

    const fetchVendedores = async () => {
        setCargandoVendedores(true);

        try {
            const response = await fetch('/api/leads/getVendedores', {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response?.ok) {
                const data = await response.json();

                setVendedores(data);
                    
                } else {
                showErrorToast(`${response?.status} ${response?.statusText}`);
                
                if (response?.status === 401) {
                    setToken(null);
                    location.href = '';
                }
            }
        } catch (error) {
            showErrorToast('Error al cargar vendedores: ' + error.message);
            console.error('Error en fetchVendedores:', error);
        } finally {
            setCargandoVendedores(false);
        }
    };

    const fetchEtapas = async () => {
        setCargandoEtapas(true);

        try {
            const response = await fetch('/api/leads/getEtapas', {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response?.ok) {
                const data = await response.json();

                setCatEtapas(data);

            } else {
                showErrorToast(`${response?.status} ${response?.statusText}`);

                if (response?.status === 401) {
                    setToken(null);
                    location.href = '';
                }
            }
        } catch (error) {
            showErrorToast('Error al cargar vendedores: ' + error.message);
            console.error('Error en fetchVendedores:', error);
        } finally {
            setCargandoEtapas(false);
        }
    };

    return (
        <Card className="mb-3 shadow-none">
            <Card.Body className="p-3">
                {/* Filtros principales */}
                <Row className="g-2 mb-3">
                    {/* Búsqueda principal */}
                    <Col xxl={4} xl={6} lg={6} md={12}>
                        <Form.Label className="mb-1 fs--1 fw-medium">
                            <FontAwesomeIcon icon="search" className="me-2 text-primary" />
                            Buscar Lead
                        </Form.Label>
                        <InputGroup size="sm">
                            <Form.Control
                                type="text"
                                placeholder="Teléfono o nombre..."
                                disabled={cargando}
                                autoComplete="off"
                                value={Filter_NumTelNameLead}
                                onChange={(e) => setFilter_NumTelNameLead(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        mostrarLeads(Filter_Tags, filtroEventosVencidos);
                                    }
                                }}
                            />
                            <Button
                                disabled={cargando}
                                variant="primary"
                                onClick={() => mostrarLeads(Filter_Tags, filtroEventosVencidos)}
                            >
                                <FontAwesomeIcon icon="search" />
                            </Button>
                        </InputGroup>
                    </Col>

                    {/* Vendedor */}
                    <Col xxl={2} xl={3} lg={3} md={6} sm={6}>
                        <Form.Label className="mb-1 fs--1 fw-medium">
                            <FontAwesomeIcon icon="user" className="me-2 text-info" />
                            Vendedor
                        </Form.Label>
                        <Form.Select
                            size="sm"
                            value={vendedor}
                            disabled={cargandoVendedores}
                            onChange={(event) => {
                                sessionStorage.setItem("selectIDUsuario", event.target.value);
                                setVendedor(event.target.value);
                            }}
                        >
                            <option value="">Todos</option>
                            {vendedores.map((vendedor, index) => (
                                <option key={index} value={vendedor.idUsuario}>
                                    {`${vendedor.vNombre} ${vendedor.vApellidos}`.trim()}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>

                    {/* Etapa */}
                    <Col xxl={2} xl={3} lg={3} md={6} sm={6}>
                        <Form.Label className="mb-1 fs--1 fw-medium">
                            <FontAwesomeIcon icon="tasks" className="me-2 text-success" />
                            Etapa
                        </Form.Label>
                        <Form.Select
                            size="sm"
                            value={etapa}
                            disabled={cargandoEtapas}
                            onChange={(event) => setEtapa(event.target.value)}
                        >
                            <option value="">Todas</option>
                            {catEtapas.map((etapa, index) => (
                                <option key={index} value={etapa.idEtapa}>
                                    {etapa.vNombreEtapa}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>

                    {/* Switches de eventos */}
                    <Col xxl={2} xl={6} lg={6} md={6}>
                        <Form.Label className="mb-1 fs--1 fw-medium d-block">
                            <FontAwesomeIcon icon="calendar-check" className="me-2 text-warning" />
                            Eventos
                        </Form.Label>
                        <div className="d-flex gap-3 align-items-center" style={{ height: '31px' }}>
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>Eventos de hoy</Tooltip>}
                            >
                                <Form.Check
                                    type="switch"
                                    id="switch-eventos-hoy"
                                    label={<small>Hoy</small>}
                                    checked={filtroEventos}
                                    onChange={handleCheckedFiltroEventos}
                                    className="mb-0"
                                />
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>Eventos vencidos</Tooltip>}
                            >
                                <Form.Check
                                    type="switch"
                                    id="switch-eventos-vencidos"
                                    label={<small className="text-danger">Vencidos</small>}
                                    checked={filtroEventosVencidosState}
                                    onChange={handleCheckedFiltroEventosVencidos}
                                    className="mb-0"
                                />
                            </OverlayTrigger>
                        </div>
                    </Col>

                    {/* Botón de filtros avanzados */}
                    <Col xxl={2} xl={6} lg={6} md={6}>
                        <Form.Label className="mb-1 fs--1 fw-medium d-block invisible">
                            Filtros
                        </Form.Label>
                        <Button
                            size="sm"
                            variant="outline-secondary"
                            onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                            className="w-100"
                        >
                            <FontAwesomeIcon 
                                icon={showAdvancedFilters ? "chevron-up" : "filter"} 
                                className="me-2" 
                            />
                            {showAdvancedFilters ? 'Ocultar' : 'Más filtros'}
                        </Button>
                    </Col>
                </Row>

                {/* Filtros avanzados (colapsables) */}
                <Collapse in={showAdvancedFilters}>
                    <div>
                        <hr className="my-2" />
                        <Row className="g-2">
                            {/* Ordenar Por */}
                            <Col xxl={3} xl={4} lg={4} md={6}>
                                <Form.Label className="mb-1 fs--1 fw-medium">
                                    <FontAwesomeIcon icon="sort" className="me-2 text-secondary" />
                                    Ordenar Por
                                </Form.Label>
                                <Form.Select
                                    size="sm"
                                    value={ordenarPor}
                                    onChange={(event) => setOrdenarPor(event.target.value)}
                                >
                                    <option value="0">Número de leads Desc.</option>
                                    <option value="1">Número de leads Asc.</option>
                                    <option value="2">Días sin actualizar Desc.</option>
                                    <option value="3">Días sin actualizar Asc.</option>
                                </Form.Select>
                            </Col>

                            {/* Fuente de Lead */}
                            <Col xxl={3} xl={4} lg={4} md={6}>
                                <Form.Label className="mb-1 fs--1 fw-medium">
                                    <FontAwesomeIcon icon="share-alt" className="me-2 text-primary" />
                                    Fuente
                                </Form.Label>
                                <Form.Select
                                    size="sm"
                                    value={idSource_}
                                    onChange={(event) => setidSource_(event.target.value)}
                                >
                                    <option value="">Todas las fuentes</option>
                                    <option value="1">WhatsApp</option>
                                    <option value="2">Messenger</option>
                                    <option value="3">Comentario Facebook</option>
                                    <option value="4">Tawk</option>
                                    <option value="5">Correo</option>
                                </Form.Select>
                            </Col>

                            {/* Tags */}
                            <Col xxl={6} xl={4} lg={4} md={12}>
                                <Form.Label className="mb-1 fs--1 fw-medium">
                                    <FontAwesomeIcon icon="tags" className="me-2 text-warning" />
                                    Etiquetas
                                </Form.Label>
                                <div className="d-flex flex-wrap gap-1" style={{ minHeight: '31px', alignItems: 'center' }}>
                                    {!tags || tags.length === 0 ? (
                                        <small className="text-muted">No hay etiquetas disponibles</small>
                                    ) : (
                                        tags
                                            .filter(tag => tag.bIsActive == 1 || tag.bIsActive === "1")
                                            .map((tag) => {
                                                const objDDLTag = Filter_Tags.find(t => t.idLeadTag === tag.idLeadTag);
                                                const isSelected = objDDLTag != null;

                                                return (
                                                    <OverlayTrigger
                                                        key={tag.idLeadTag}
                                                        placement="top"
                                                        overlay={<Tooltip><strong>{tag.vNombreTag}</strong></Tooltip>}
                                                    >
                                                        <span
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                let _filterTags = [...Filter_Tags];
                                                                if (!isSelected) {
                                                                    _filterTags.push(tag);
                                                                    setFilter_Tags(_filterTags);
                                                                } else {
                                                                    _filterTags = Filter_Tags.filter((item) => item.idLeadTag !== tag.idLeadTag);
                                                                    setFilter_Tags(_filterTags);
                                                                }
                                                                mostrarLeads(_filterTags, filtroEventosVencidos);
                                                            }}
                                                        >
                                                            <SoftBadge
                                                                className={!isSelected ? "border border-secondary" : ""}
                                                                bg={!isSelected ? "light" : objDDLTag?.colorActive || "secondary"}
                                                            >
                                                                {isSelected && <FontAwesomeIcon icon="check" className="me-1" size="xs" />}
                                                                {tag.vAbreviacionTag}
                                                            </SoftBadge>
                                                        </span>
                                                    </OverlayTrigger>
                                                );
                                            })
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Collapse>
            </Card.Body>
        </Card>
    );
};

FiltrosContactos.propTypes = {
    vendedor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setVendedor: PropTypes.func.isRequired,
    catEtapas: PropTypes.array.isRequired,
    setCatEtapas: PropTypes.func.isRequired,
    etapa: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setEtapa: PropTypes.func.isRequired,
    ordenarPor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setOrdenarPor: PropTypes.func.isRequired,
    idSource_: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setidSource_: PropTypes.func.isRequired,
    tags: PropTypes.array.isRequired,
    Filter_Tags: PropTypes.array.isRequired,
    setFilter_Tags: PropTypes.func.isRequired,
    mostrarLeads: PropTypes.func.isRequired,
    filtroEventosVencidos: PropTypes.bool.isRequired,
    Filter_NumTelNameLead: PropTypes.string.isRequired,
    setFilter_NumTelNameLead: PropTypes.func.isRequired,
    filtroEventos: PropTypes.bool.isRequired,
    handleCheckedFiltroEventos: PropTypes.func.isRequired,
    handleCheckedFiltroEventosVencidos: PropTypes.func.isRequired,
    cargando: PropTypes.bool.isRequired
};

export default FiltrosContactos;
